import { GRAMMAR_CLIP_SOURCES, GRAMMAR_CLIP_STATUSES } from '@repo/config';
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { getGrammarPointV1DataSchema } from '../getGrammarPointV1';
import { listSysGrammarPointsV1DataSchema } from '../listSysGrammarPointsV1';
import { grammarClipResponseSchema, grammarItemResponseSchema } from '../schemas';

const sysGrammarClipLinkSchema = grammarClipResponseSchema.extend({
  linkId: z.number().int(),
  source: z.enum(GRAMMAR_CLIP_SOURCES),
  status: z.enum(GRAMMAR_CLIP_STATUSES),
  createdAt: z.number().int(),
});

const getSysGrammarPointV1DataSchemaDefinition = z.object({
  point: listSysGrammarPointsV1DataSchema.shape.points.element,
  items: z.array(grammarItemResponseSchema),
  itemCounts: getGrammarPointV1DataSchema.shape.itemCounts,
  clipLinks: z.array(sysGrammarClipLinkSchema),
});

export const getSysGrammarPointV1DataSchema: typeof getSysGrammarPointV1DataSchemaDefinition =
  getSysGrammarPointV1DataSchemaDefinition;

export type IGetSysGrammarPointV1Data = z.infer<typeof getSysGrammarPointV1DataSchema>;

export const getSysGrammarPointV1ResponseSchema: z.ZodSchema<IAPI<IGetSysGrammarPointV1Data>> =
  createApiResponseSchema(getSysGrammarPointV1DataSchema) as z.ZodSchema<
    IAPI<IGetSysGrammarPointV1Data>
  >;

export type IGetSysGrammarPointV1Response = IAPI<IGetSysGrammarPointV1Data>;
